import {AccessLevelPackages} from "./types";
import Utils from "../utils/utils";
import EnvService from "../env";

export const initialPackages: AccessLevelPackages = {
    base: {
        versionHistory: false,
        birthdayDialog: false,

        connectedApps: false,
        connectedAppsBizHr: false,
        connectedAppsBizCms: false,
        connectedAppsBizCore: false,
        connectedAppsBizCrm: false,
        connectedAppsBizInventory: false,
        connectedAppsBizLearn: false,
        connectedAppsBizQrCode: false,
        connectedAppsBizProduction: false,

        contentBlogs: false,
        contentVideos: false,

        personalSettings: false,
        organizationSettings: false,
        partnershipSettings: false,
        importing: false,
        manageRegions: false,
        retailUserSettings: false,
        accountingSystemSettings: false,
        paymentProvidersSettings: false,
        freightProviderSettings: false,
        partnerColorThemeSettings: false,
        partnersManagementSettings: false,

        customerDetails: false,
        exportCustomerNotes: false,
        exportCustomersList: false,
        customerList: false,
        exportCustomerMembersList: false,
        customerMembersList: false,
        customerLoginLogs: false,
        manageCustomerLimitations: false,
        manageCustomerMemberAccessLevels: false,
        createCustomerMember: false,
        createCustomer: false,
        removeCustomer: false,
        importExternalCustomer: false,
        importExternalVendor: false,

        editOwnProfile: false,
        editPartnerProfile: false,
        operatorsList: false,
        exportOperatorsList: false,
        manageOperators: false,
        manageAccessLevels: false,
        exportRegionsList: false,
        exportTaxesList: false,
        exportTerritoriesList: false,
        exportSalesPersonsAccessLevels: false,
        exportSalesTax: false,
        manageTaxes: false,
        manageTerritories: false,

        viewVendors: false,
        exportVendorsList: false,
        createNewVendor: false,
        viewVendorAccountInfo: false,
        manageVendorAccountInfo: false,
        viewVendorNotes: false,
        exportVendorNotes: false,
        manageVendorNotes: false,
        viewVendorProducts: false,
        manageVendorProducts: false,
        exportVendorProducts: false,


        frenchLanguageSupport: false,
        spanishLanguageSupport: false,
    },
    bizInventory: {
        availabilityInLookup: false,
        minimumRequiredAvailability: false,
        manageMinimumRequiredAvailability: false,

        transferList: false,
        submitTransfer: false,
        transferHistoryList: false,
        transferHistoryItems: false,
        transferInformation: false,

        submitAdjustment: false,
        manageAdjustmentReasons: false,
        adjustmentList: false,
        adjustmentItems: false,
        adjustmentReports: false,
        bulkAdjustments: false,
        adjustmentInformation: false,

        viewAvailabilityThresholds: false,
        manageAvailabilityThresholds: false,
        exportAvailabilityThresholds: false,

        /** Settings → Import: set warehouse on-hand quantities via Inventory/SetInventoryAvailability */
        setInventoryAvailability: false,

        exportInventoryTransferHistory: false,
        exportInventoryAdjustments: false,
        exportInventoryAdjustmentReports: false,

    },
    lookup: {
        nexusSearch: false,
        vinDecoder: false,
        aggregatedVariantsNexusSearch: false,

        lookupProductInformation: false,
        viewCompetitors: false,
        manageCompetitors: false,
        exportCompetitors: false,
        reportCompetitorPrice: false,
        viewAllCompetitorPriceReports: false,
        viewMyCompetitorPriceReports: false,
        manageCompetitorPriceReports: false,
        exportCompetitorPriceReports: false,
        comparisonList: false,
        submitLostSearch: false,
        productOnPurchaseList: false,
        productOnBackorderList: false,
        manageProductOnPurchaseList: false,
        productVariants: false,
        manageProductVariants: false,

        products: false,
        createNewProduct: false,
        productInformation: false,
        copyProduct: false,
        removeProduct: false,
        editProductBasicInformation: false,
        editProductPricing: false,
        allowPriceFormulas: false,
        editProductInventory: false,
        editProductTechnicalInformation: false,
        editProductImages: false,
        editProductTechnicalFiles: false,
        editProductNotes: false,
        editProductRelations: false,
        editProductFeedbacks: false,
        editProductCodes: false,
        editProductPropertyGroups: false,
        editProductDimensions: false,
        editProductPartNo: false,
        importExternalProduct: false,
        bulkProductCategoryAssignment: false,
        bulkPriceChanges: false,

        applicationSuggestionsList: false,
        applicationSuggestionsManage: false,
        technicalSuggestionsList: false,
        technicalSuggestionsManage: false,
        submitTechnicalSuggestions: false,
        submitApplicationSuggestions: false,
        manageProductProperties: false,
        manageProductPropertiesSettings: false,
        manageProductForms: false,

        fastConnection: false,
        manageTags: false,
        manageCategories: false,
        manageRelationTypes: false,
        manageCodeTypes: false,
        manageIndustries: false,
        manageSharingRules: false,
        missingPublicProductsList: false,
        exportSystemProductsBasicInformation: false,
        exportProductPrices: false,
        exportProductPriceHistory: false,
        exportProductCostHistory: false,
        exportBulkPriceChangeDashboard: false,
        exportBulkPriceChangeReport: false,
        exportAffectedProducts: false,

    },
    warrantyAndReturn: {
        viewList: false,
        viewDetails: false,
        submitRequest: false,
        editRequest: false,
        editConfigurations: false,
        drivers: false,
        extraRequestInformation: false,
        chatWithCustomer: false,
        chatWithVendor: false,
        manageVendor: false,
        exportPartSupportRequests: false,
        exportWarrantyDrivers: false,
    },
    sales: {
        submitLostSales: false,
        pricesInLookup: false,
        changeProductPricesInLookup: false,
        submitQuoteInLookup: false,

        quickOrder: false,

        customerShoppingCart: false,
        manageCustomerAddresses: false,
        manageCustomerPaymentMethods: false,
        manageSalesPersonsAccessLevels: false,
        manageTaxesForProductWarehouses: false,
        chargeCreditCards: false,
        paymentReceipts: false,
        paymentMethodsTransactionHistory: false,
        importAndExportTerritoriesAndAccountManagers: false,
        exportTerritoriesAndAccountManagers: false,

        allowDuplicatePartNumbersInOrders: false,
        allowDecimalQuantityInOrders: false,

        createOrderFromAnother: false,

        warehouseSchedules: false,
        manageWarehouseSchedules: false,

        salesPerson: false,
        quoteBypass: false,
        manageQuoteBypassReasons: false,
        quotesList: false,
        exportQuotesList: false,
        quoteInformation: false,
        manageQuotes: false,
        manageWarehousesInQuote: false,
        manageUnitPriceInQuote: false,

        salesOrdersList: false,
        exportSalesOrdersList: false,
        exportBackOrdersList: false,
        salesOrderInformation: false,
        manageSalesOrders: false,

        invoicesList: false,
        exportInvoicesList: false,
        invoiceInformation: false,
        manageInvoices: false,

        issueCredit: false,
        creditsList: false,
        exportCreditsList: false,
        creditInformation: false,
        manageCredits: false,
        customerAvailableCredits: false,
        exportCustomerAvailableCredits: false,
        exportCustomerCreditsSummary: false,

        accountReceivables: false,
        exportAccountReceivables: false,
        customerAccountReceivableTransactions: false,
        exportCustomerAccountReceivableTransactions: false,
        onlinePaymentTransactionHistory: false,
        exportOnlinePaymentTransactions: false,
        onlinePayments: false,
        invoiceMultiPayments: false,
        refundInvoiceTransactions: false,

        viewPriceMatrices: false,
        managePriceMatrices: false,
        exportPriceMatrices: false,
        customerPriceMatrices: false,

        quoteFreightInfo: false,
        orderFreightInfo: false,
        freightFees: false,
        exportShippingFeesList: false,
        freeFreightFees: false,
        customerFreeFreightFees: false,
        customerFreightFees: false,
        freightCompanies: false,
        freightReports: false,
        exportShippingFeeReports: false,
        regionRates: false,
        manageRegionRates: false,
        partRates: false,
        managePartRates: false,

        salesPallets: false,
        manageSalesPallets: false,

        giftCards: false,
        exportGiftCardsList: false,
        manageGiftCards: false,
        customerGiftCards: false,
        exportCustomerGiftCards: false,
        managePriceLevels: false,
        promotions: false,
        exportPromotionsList: false,
        customerPromotions: false,
        exportCustomerPromotionUsages: false,

        troubleshootTransactionsList: false,
    },
    bizPrint: {
        printProductInformation: false,
        printLabels: false,
        printCatalogue: false,
        printHub: false,
        printPackingList: false,
        printBrochure: false,

        manageTemplates: false,
        emailTemplate: false,

        printCredit: false,
        printInvoice: false,
        printQuote: false,
        printSalesOrder: false,
        printTransactionInTroubleshoot: false,
        printCustomerOutstandingStatement: false,
        printWarrantyAndReturnClaim: false,
        printPurchaseOrder: false,
        printPurchaseHistory: false,
    },
    clientPlatform: {
        shareProductLink: false,
        shareTechnicalFileLink: false,
        liveHomepages: false,

        webHomepageEditions: false,
        phoneHomepageEditions: false,
        exportHomepageEditions: false,
        manageWebHomepageEditions: false,
        managePhoneHomepageEditions: false,
        contentManagement: false,
        surveys: false,
        exportSurveys: false,
        themeManagement: false,
        bannerManagement: false,
        viewDynamicPages: false,
        exportDynamicPages: false,
        manageDynamicPages: false,
    },
    taskNote: {
        tasks: false,
        notes: false,
        welcomeToPanelTasksDialog: false,
        notebook: false,
    },
    bizCrm: {},
    ncr: {
        viewList: false,
        viewDetails: false,
        manageReport: false,
        notes: false,
        exportNcrNotes: false,
        exportNcrList: false,
        exportNcrActionTable: false,
        tasks: false,
        editConfigurations: false,
    },
    notifications: {
        customerMembersNotificationChannels: false,
        viewList: false,
        manageList: false,
        customerNotifications: false,
        manageCustomerNotifications: false,
    },
    dashboard: {
        systemWideDashboards: false,
        systemWideReports: false,
        lookupAnalytics: false,
        exportLookupAnalytics: false,
        lostSalesAnalytics: false,
        exportLostSalesAnalytics: false,
        viewDashboards: false,
        manageOwnDashboardConfigs: false,
        viewDashboardWidgetFilters: false,
        manageDashboardWidgetFilters: false,
        manageDashboards: false,
        exportDashboardWidgets: false,
        lookupLogs: false,
        exportLookupAnalyticsLogs: false,
        lostSalesLogs: false,
        exportLostSalesLogs: false,
        productInformationStats: false,
        customerInformationStats: false,
        vendorInformationStats: false,
    },
    purchasing: {
        viewPurchaseOrders: false,
        exportPurchaseOrdersList: false,
        submitPurchaseOrder: false,
        viewPurchaseOrderDetails: false,
        managePurchaseOrderDetails: false,
        viewPurchaseHistory: false,
        exportPurchaseHistory: false,
        viewPurchasePlanning: false,
        managePurchasePlanning: false,
        exportPurchasePlanning: false,
    },
    timeTracker: {
        timeTracker: false,
        reports: false,
    },
    bizFile: {
        viewPlugin: false,
    },
    bizForm: {
        formsList: false,
        formsManage: false,
        formResponsesList: false,
        formResponsesManage: false,
    },
    bizPoint: {
        loyaltyDashboard: false,
        exportLoyaltyDashboard: false,
        loyaltyBuyBiz: false,
        exportLoyaltyBuyBiz: false,
        loyaltyEarningRules: false,
        exportLoyaltyEarningRules: false,
        loyaltyEarningRulesManage: false,
        loyaltyCustomers: false,
        exportLoyaltyCustomers: false,
        loyaltyCustomersManage: false,
        loyaltySettings: false,
        adminReviewQueue: false,
        exportAdminReviewQueue: false,
        adminManualAdjustment: false,
        adminBusinessConfig: false,
        exportAdminBusinessConfig: false,
        adminLiabilityReport: false,
        exportAdminLiabilityReport: false,
        adminAuditLog: false,
        exportAdminAuditLog: false,
        adminPurchaseConfirm: false,
        exportAdminPurchaseConfirm: false,
        adminWalletSuspend: false,
    },
    support: {
        contactUsMessages: false,
        exportContactUsMessages: false,
    },
};

export const generalAccessLevelsData: DeepPartial<AccessLevelPackages> = {
    base: {
        versionHistory: true,
        birthdayDialog: true,

        connectedApps: true,
        connectedAppsBizCms: true,
        connectedAppsBizCore: true,
        connectedAppsBizCrm: true,
        connectedAppsBizInventory: true,
        connectedAppsBizLearn: true,
        connectedAppsBizQrCode: true,

        contentBlogs: true,
        contentVideos: true,

        personalSettings: true,
        organizationSettings: true,
        partnershipSettings: true,
        importing: true,
        manageRegions: true,
        retailUserSettings: true,
        accountingSystemSettings: true,
        paymentProvidersSettings: true,
        freightProviderSettings: true,
        partnerColorThemeSettings: true,
        partnersManagementSettings: false,

        customerDetails: true,
        exportCustomerNotes: true,
        exportCustomersList: true,
        customerList: true,
        exportCustomerMembersList: true,
        customerMembersList: true,
        customerLoginLogs: true,
        manageCustomerLimitations: true,
        manageCustomerMemberAccessLevels: true,
        createCustomerMember: true,
        createCustomer: true,
        removeCustomer: true,
        importExternalCustomer: true,
        importExternalVendor: true,

        editOwnProfile: true,
        editPartnerProfile: true,
        operatorsList: true,
        exportOperatorsList: true,
        manageOperators: true,
        manageAccessLevels: true,
        exportRegionsList: true,
        manageTaxes: true,
        exportTaxesList: true,
        exportTerritoriesList: true,
        manageTerritories: true,
        exportSalesPersonsAccessLevels: true,
        exportSalesTax: true,

        createNewVendor: true,
        viewVendors: true,
        exportVendorsList: true,
        viewVendorAccountInfo: true,
        manageVendorAccountInfo: true,
        viewVendorNotes: true,
        exportVendorNotes: true,
        manageVendorNotes: true,
        viewVendorProducts: true,
        manageVendorProducts: true,
        exportVendorProducts: true,

        frenchLanguageSupport: true,
        spanishLanguageSupport: true,
    },
    bizInventory: {
        availabilityInLookup: true,
        minimumRequiredAvailability: false,
        manageMinimumRequiredAvailability: false,

        transferList: true,
        submitTransfer: true,
        transferHistoryList: true,
        transferHistoryItems: true,
        transferInformation: true,

        submitAdjustment: true,
        manageAdjustmentReasons: true,
        adjustmentList: true,
        adjustmentItems: true,
        adjustmentReports: true,
        bulkAdjustments: true,
        adjustmentInformation: true,

        viewAvailabilityThresholds: true,
        manageAvailabilityThresholds: true,
        exportAvailabilityThresholds: true,
        setInventoryAvailability: false,

        exportInventoryTransferHistory: true,
        exportInventoryAdjustments: true,
        exportInventoryAdjustmentReports: true,
    },
    lookup: {
        nexusSearch: true,
        vinDecoder: true,
        aggregatedVariantsNexusSearch: false,

        lookupProductInformation: true,
        viewCompetitors: true,
        manageCompetitors: true,
        exportCompetitors: true,
        reportCompetitorPrice: true,
        viewAllCompetitorPriceReports: true,
        viewMyCompetitorPriceReports: true,
        manageCompetitorPriceReports: true,
        exportCompetitorPriceReports: true,
        comparisonList: true,
        submitLostSearch: true,
        productOnPurchaseList: true,
        productOnBackorderList: true,
        manageProductOnPurchaseList: true,
        productVariants: true,
        manageProductVariants: true,

        products: true,
        createNewProduct: true,
        productInformation: true,
        copyProduct: true,
        removeProduct: true,
        editProductBasicInformation: true,
        editProductPricing: true,
        allowPriceFormulas: true,
        editProductInventory: true,
        editProductTechnicalInformation: true,
        editProductImages: true,
        editProductTechnicalFiles: true,
        editProductNotes: true,
        editProductRelations: true,
        editProductFeedbacks: true,
        editProductCodes: true,
        editProductPropertyGroups: true,
        editProductDimensions: true,
        editProductPartNo: true,
        importExternalProduct: true,
        bulkProductCategoryAssignment: true,
        bulkPriceChanges: true,

        applicationSuggestionsList: true,
        applicationSuggestionsManage: true,
        technicalSuggestionsList: true,
        technicalSuggestionsManage: true,
        submitTechnicalSuggestions: true,
        submitApplicationSuggestions: true,

        manageProductProperties: true,
        manageProductPropertiesSettings: false,
        manageProductForms: true,

        fastConnection: true,
        manageTags: true,
        manageCategories: true,
        manageRelationTypes: true,
        manageCodeTypes: true,
        manageIndustries: true,

        missingPublicProductsList: true,
        exportSystemProductsBasicInformation: true,
        exportProductPrices: true,
        exportProductPriceHistory: true,
        exportProductCostHistory: true,
        exportBulkPriceChangeDashboard: true,
        exportBulkPriceChangeReport: true,
        exportAffectedProducts: true,
    },
    warrantyAndReturn: {
        viewList: true,
        viewDetails: true,
        submitRequest: true,
        editRequest: true,
        editConfigurations: true,
        drivers: true,
        extraRequestInformation: true,
        chatWithCustomer: true,
        chatWithVendor: true,
        manageVendor: true,
        exportPartSupportRequests: true,
        exportWarrantyDrivers: true,
    },
    sales: {
        submitLostSales: true,
        pricesInLookup: true,
        changeProductPricesInLookup: true,
        submitQuoteInLookup: true,

        quickOrder: true,

        customerShoppingCart: true,
        manageCustomerAddresses: true,
        manageCustomerPaymentMethods: true,
        manageSalesPersonsAccessLevels: true,
        manageTaxesForProductWarehouses: true,
        chargeCreditCards: true,
        paymentReceipts: true,
        paymentMethodsTransactionHistory: true,
        importAndExportTerritoriesAndAccountManagers: true,
        exportTerritoriesAndAccountManagers: true,

        createOrderFromAnother: true,

        warehouseSchedules: true,
        manageWarehouseSchedules: true,

        salesPerson: true,
        quoteBypass: true,
        manageQuoteBypassReasons: true,
        quotesList: true,
        exportQuotesList: true,
        quoteInformation: true,
        manageQuotes: true,
        manageWarehousesInQuote: true,
        manageUnitPriceInQuote: true,

        salesOrdersList: true,
        exportSalesOrdersList: true,
        exportBackOrdersList: true,
        salesOrderInformation: true,
        manageSalesOrders: true,

        invoicesList: true,
        exportInvoicesList: true,
        invoiceInformation: true,
        manageInvoices: true,

        issueCredit: true,
        creditsList: true,
        exportCreditsList: true,
        creditInformation: true,
        manageCredits: true,
        customerAvailableCredits: true,
        exportCustomerAvailableCredits: true,
        exportCustomerCreditsSummary: true,

        accountReceivables: true,
        exportAccountReceivables: true,
        customerAccountReceivableTransactions: true,
        exportCustomerAccountReceivableTransactions: true,
        onlinePaymentTransactionHistory: true,
        exportOnlinePaymentTransactions: true,
        onlinePayments: true,
        invoiceMultiPayments: true,
        refundInvoiceTransactions: true,

        viewPriceMatrices: true,
        managePriceMatrices: true,
        exportPriceMatrices: true,
        customerPriceMatrices: true,

        quoteFreightInfo: true,
        orderFreightInfo: true,
        freightFees: true,
        exportShippingFeesList: true,
        freeFreightFees: true,
        customerFreeFreightFees: true,
        customerFreightFees: true,
        freightCompanies: true,
        freightReports: true,
        exportShippingFeeReports: true,
        regionRates: true,
        manageRegionRates: true,
        partRates: true,
        managePartRates: true,

        salesPallets: true,
        manageSalesPallets: true,

        giftCards: true,
        exportGiftCardsList: true,
        manageGiftCards: true,
        customerGiftCards: true,
        exportCustomerGiftCards: true,
        managePriceLevels: true,
        promotions: true,
        exportPromotionsList: true,
        customerPromotions: true,
        exportCustomerPromotionUsages: true,

        troubleshootTransactionsList: true,
    },
    bizPrint: {
        printProductInformation: true,
        printLabels: true,
        printCatalogue: true,
        printHub: true,
        printPackingList: true,
        printBrochure: true,

        manageTemplates: true,
        emailTemplate: true,

        printCredit: true,
        printInvoice: true,
        printQuote: true,
        printSalesOrder: true,
        printTransactionInTroubleshoot: true,
        printCustomerOutstandingStatement: true,
        printWarrantyAndReturnClaim: true,
        printPurchaseOrder: true,
        printPurchaseHistory: true,
    },
    clientPlatform: {
        shareProductLink: true,
        shareTechnicalFileLink: true,
        liveHomepages: true,
        webHomepageEditions: true,
        phoneHomepageEditions: true,
        exportHomepageEditions: true,
        manageWebHomepageEditions: true,
        managePhoneHomepageEditions: true,
        contentManagement: true,
        surveys: false,
        exportSurveys: false,
        themeManagement: false,
        bannerManagement: true,
        viewDynamicPages: true,
        exportDynamicPages: true,
        manageDynamicPages: true,
    },
    taskNote: {
        tasks: true,
        notes: true,
        welcomeToPanelTasksDialog: true,
        notebook: true,
    },
    bizCrm: {},
    ncr: {
        viewList: true,
        viewDetails: true,
        manageReport: true,
        notes: true,
        exportNcrNotes: true,
        exportNcrList: true,
        exportNcrActionTable: true,
        tasks: true,
        editConfigurations: true,
    },
    notifications: {
        customerMembersNotificationChannels: true,
        viewList: true,
        manageList: true,
        customerNotifications: true,
        manageCustomerNotifications: true,
    },
    dashboard: {
        systemWideDashboards: true,
        systemWideReports: true,
        lookupAnalytics: true,
        exportLookupAnalytics: true,
        lostSalesAnalytics: true,
        exportLostSalesAnalytics: true,
        viewDashboards: true,
        manageOwnDashboardConfigs: true,
        viewDashboardWidgetFilters: true,
        manageDashboardWidgetFilters: true,
        manageDashboards: true,
        exportDashboardWidgets: true,
        lookupLogs: true,
        exportLookupAnalyticsLogs: true,
        lostSalesLogs: true,
        exportLostSalesLogs: true,
        customerInformationStats: true,
        productInformationStats: true,
        vendorInformationStats: true,
    },
    purchasing: {
        viewPurchaseOrders: true,
        exportPurchaseOrdersList: true,
        submitPurchaseOrder: true,
        viewPurchaseOrderDetails: true,
        managePurchaseOrderDetails: true,
        viewPurchaseHistory: true,
        exportPurchaseHistory: true,
        viewPurchasePlanning: true,
        managePurchasePlanning: true,
        exportPurchasePlanning: true,
    },
    timeTracker: {
        timeTracker: true,
        reports: true,
    },
    bizFile: {
        viewPlugin: true,
    },
    bizForm: {
        formsList: true,
        formsManage: true,
        formResponsesList: true,
        formResponsesManage: true,
    },
    bizPoint: {
        loyaltyDashboard: true,
        exportLoyaltyDashboard: true,
        loyaltyBuyBiz: true,
        exportLoyaltyBuyBiz: true,
        loyaltyEarningRules: true,
        exportLoyaltyEarningRules: true,
        loyaltyEarningRulesManage: true,
        loyaltyCustomers: true,
        exportLoyaltyCustomers: true,
        loyaltyCustomersManage: true,
        loyaltySettings: true,
        adminReviewQueue: true,
        exportAdminReviewQueue: true,
        adminManualAdjustment: true,
        adminBusinessConfig: true,
        exportAdminBusinessConfig: true,
        adminLiabilityReport: true,
        exportAdminLiabilityReport: true,
        adminAuditLog: true,
        exportAdminAuditLog: true,
        adminPurchaseConfirm: true,
        exportAdminPurchaseConfirm: true,
        adminWalletSuspend: true,
    },
    support: {
        contactUsMessages: true,
        exportContactUsMessages: true,
    },
}

export const basicEssentialAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, generalAccessLevelsData, {
    base: {
        connectedAppsBizCms: false,
    },
    warrantyAndReturn: initialPackages.warrantyAndReturn,
    sales: {
        troubleshootTransactionsList: false,
    },
    clientPlatform: {
        phoneHomepageEditions: false,
        managePhoneHomepageEditions: false,
    },
    bizPrint: {
        printProductInformation: false,
        printLabels: false,
        printCatalogue: false,
        printHub: false,
        printPackingList: false,
        printBrochure: false,
    },
    taskNote: initialPackages.taskNote,
    ncr: initialPackages.ncr,
    dashboard: {
        systemWideDashboards: false,
        systemWideReports: false,
    },
    purchasing: initialPackages.purchasing,
} as DeepPartial<AccessLevelPackages>);


// ---------------------------------------------- The following are the access levels for each of the Partners ----------------------------------------------

const DemoAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, generalAccessLevelsData, {
    lookup: {
        // Demo partner: aggregation on for every industry (OR with industry allowlist).
        aggregatedVariantsNexusSearch: true,
    },
} as DeepPartial<AccessLevelPackages>);

const AISandboxUserAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, initialPackages, {
    base: {
        customerDetails: true,
        customerList: true,
        customerMembersList: true,
        manageCustomerLimitations: true,
        manageCustomerMemberAccessLevels: true,
        createCustomerMember: true,
        createCustomer: true,
        removeCustomer: true,
    },
    bizInventory: {
        availabilityInLookup: true,
    },
    lookup: {
        nexusSearch: true,
        lookupProductInformation: true,
        submitLostSearch: true,
        productVariants: true,
    },
    sales: {
        submitLostSales: true,
        submitQuoteInLookup: true,
        quickOrder: true,
        salesPerson: true,
        pricesInLookup: true,
        quotesList: true,
        quoteInformation: true,
        manageQuotes: true,
        manageCustomerAddresses: true,
        warehouseSchedules: true,
        manageWarehouseSchedules: true,
    },

} as DeepPartial<AccessLevelPackages>);

const DemoUserAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, DemoAccessLevelsData, {
    base: {
        partnersManagementSettings: true,
    }
} as DeepPartial<AccessLevelPackages>);

const CHTPAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, generalAccessLevelsData, {
    base: {
        connectedAppsBizProduction: true,
    },
    clientPlatform: {
        surveys: true,
        exportSurveys: true,
        themeManagement: true,
    },
    sales: {
        issueCredit: false,
        refundInvoiceTransactions: false,
    },
} as DeepPartial<AccessLevelPackages>);

const JmacAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: false,
        accountingSystemSettings: false,
    },
} as DeepPartial<AccessLevelPackages>);

const TruxPartsAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {} as DeepPartial<AccessLevelPackages>);

const SinkutRadiatorsAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: true,
        accountingSystemSettings: false,
        partnershipSettings: true,
        viewVendors: false,
    },
    bizInventory: {
        setInventoryAvailability: true,
    },
    sales: {
        ...initialPackages.sales,
        managePriceLevels: true,
        pricesInLookup: true,
        changeProductPricesInLookup: true,
        warehouseSchedules: true,
        manageWarehouseSchedules: true,
    },
    bizForm: initialPackages.bizForm,
    lookup: {
        manageProductForms: false,
    },
    dashboard: initialPackages.dashboard,

} as DeepPartial<AccessLevelPackages>);

const HorsebarnAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: false
    },
} as DeepPartial<AccessLevelPackages>);

const MyersAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: true
    },
} as DeepPartial<AccessLevelPackages>);

const CascadeAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, initialPackages, {
    dashboard: {
        viewDashboards: true,
        exportDashboards: true,
        manageOwnDashboardConfigs: true,
        viewDashboardWidgetFilters: true,
        manageDashboardWidgetFilters: true,
        manageDashboards: true,
        exportDashboardWidgets: true,
    },
    base: {
        versionHistory: true,
        operatorsList: true,
        manageOperators: true,
        exportOperatorsList: true,
        editOwnProfile: true,
        editPartnerProfile: true,
    },
} as DeepPartial<AccessLevelPackages>);

const AutoPartDemoAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: true,
        accountingSystemSettings: true,
    },
    clientPlatform: initialPackages.clientPlatform,
    bizForm: initialPackages.bizForm,
    lookup: {
        manageProductForms: false,
    },
} as DeepPartial<AccessLevelPackages>);

const CHTPEdmontonAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, basicEssentialAccessLevelsData, {
    base: {
        connectedAppsBizInventory: true,
        accountingSystemSettings: false,
    },
    warrantyAndReturn: generalAccessLevelsData.warrantyAndReturn,
    bizPrint: {
        printWarrantyAndReturnClaim: true,
    },
    bizForm: initialPackages.bizForm,
    lookup: {
        manageProductForms: false,
    },
} as DeepPartial<AccessLevelPackages>);

// const DemoUserAccessLevelsData: DeepPartial<AccessLevelPackages> = Utils.deepMerge({}, SinkutRadiatorsAccessLevelsData);

/**
 * Get the access levels data by the partner id.
 * @param partnerId
 * @param userId
 * @constructor
 */
export const AccessLevelDataByPartnerId = (partnerId: string, userId: string): DeepPartial<AccessLevelPackages> => {
    let response: DeepPartial<AccessLevelPackages>;
    switch (userId?.toUpperCase()) {
        case EnvService.DefinedUserIds.aiSandbox.toUpperCase():
            response = AISandboxUserAccessLevelsData;
            break;
        case EnvService.DefinedUserIds.demo.toUpperCase():
            response = DemoUserAccessLevelsData;
            break;
        default:
            switch (partnerId?.toUpperCase()) {
                case EnvService.DefinedPartnerIds.demo.toUpperCase():
                    response = DemoAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.chtp.toUpperCase():
                    response = CHTPAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.chtpEdmonton.toUpperCase():
                    response = CHTPEdmontonAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.truxparts.toUpperCase():
                    response = TruxPartsAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.jmac.toUpperCase():
                    response = JmacAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.horsebarn.toUpperCase():
                    response = HorsebarnAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.myers.toUpperCase():
                    response = MyersAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.cascade.toUpperCase():
                    response = CascadeAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.autoPartDemo.toUpperCase():
                    response = AutoPartDemoAccessLevelsData;
                    break;
                case EnvService.DefinedPartnerIds.sinkut.toUpperCase():
                    response = SinkutRadiatorsAccessLevelsData;
                    break;
                default:
                    response = {};
                    break;
            }
    }
    return response;
};

